import JournalGroup from './JournalGroup';
import type { JournalGroupProps, BlogPost } from './JournalGroup';

export type { JournalGroupProps, BlogPost };
export default JournalGroup;
